import React, { useEffect, useState } from "react";

import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

import { showLevels, updateLevels } from "../../../../MyApi/hr/levels";

import PageHeader from "../../../../Components/UI/PageHeader";
import EditLevel from "../../../../Components/hr/levels/levelsUpdate/AddLevel";
import LoadingSpinner from "../../../../Components/UI/spinner";

const LevelsUpdate = () => {
  const [levelName, setLevelName] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [description, setDescription] = useState("");
  const [active, setActive] = useState(0);
  const [selectedOption, setSelectedOption] = useState("");
  const lang = localStorage.getItem("i18nextLng");
  const [selectedCodeLang, setSelectedCodeLang] = useState(lang);
  const [rulesArr, setRules] = useState([]);
  const { id } = useParams();
  const { data, isLoading } = useQuery(
    ["showLevels", id, selectedCodeLang],
    () => showLevels(id, selectedCodeLang)
  );
  const mutation = useMutation(
    ["updateLevels", id, selectedCodeLang],
    (postData) => updateLevels(postData, id, selectedCodeLang),
    {
      onSuccess: (data) => {
        toast.success(`${data.message}`);
      },
      onError: (error) => {
        toast.error(`${error.response.data.message}`);
      },
    }
  );
  const levels = data?.data || [];
  useEffect(() => {
    setLevelName(levels.name);
    setCompanyId(levels.company_id);
    setActive(levels.active);
    setDescription(levels.description);
    setRules(levels.rules ||[]);
  }, [levels]);

  const handlePostRequest = () => {
    mutation.mutate({
      name: levelName,
      description,
      active,
      sb_company_id: +companyId,
      rules:rulesArr,
      lang_code: selectedCodeLang,
    });
  };
  const isDisabled = () => {
    return !(levelName && companyId && description);
  };
  const onSelectChange = (e) => {
    setSelectedCodeLang(e.target.value);
  };
  if (isLoading) {
    return <LoadingSpinner />;
  }
  if (!data) {
    return <div>no data available</div>;
  }
  return (
    <div>
      <PageHeader
        showSelect
        onSelectChange={onSelectChange}
        title="Edit Level"
        showBack={true}
        saveButton={true}
        isdisbled={isDisabled}
        handlePostRequest={handlePostRequest}
      />
      <EditLevel
        rulesArr={rulesArr}
        companyId={companyId}
        setLevelName={setLevelName}
        setSelectedOption={setSelectedOption}
        selectedOption={selectedOption}
        setCompanyId={setCompanyId}
        levelName={levelName}
        setDescription={setDescription}
        description={description}
        setActive={setActive}
        active={active}
      />
    </div>
  );
};

export default LevelsUpdate;
